import type { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ReRouteComponent } from './shared/components/re-route/re-route.component';
import { requirePermissions } from './core/guards/permissions.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ReRouteComponent,
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./shared/components/with-navigation/with-navigation.component').then((m) => m.WithNavigationComponent),
    children: [
      {
        path: 'tenants',
        canActivate: [requirePermissions('TENANT_READ')],
        children: [
          {
            path: '',
            loadComponent: () => import('./features/tenant-list/tenant-list.component').then((m) => m.TenantListComponent),
          },
          {
            path: 'create',
            canActivate: [requirePermissions('TENANT_WRITE')],
            loadComponent: () => import('./features/tenant-create/tenant-create.component').then((m) => m.TenantCreateComponent),
          },
          {
            path: ':id/update',
            canActivate: [requirePermissions('TENANT_WRITE')],
            loadComponent: () => import('./features/tenant-update/tenant-update.component').then((m) => m.TenantUpdateComponent),
          },
          {
            path: ':id/metadata-config',
            canActivate: [requirePermissions('TENANT_WRITE')],
            loadComponent: () => import('./features/tenant-metadata-config/tenant-metadata-config.component').then((m) => m.TenantMetadataConfigComponent),
          },
        ],
      },
      {
        path: 'integrations',
        canActivate: [requirePermissions('INTEGRATION_READ')],
        children: [
          {
            path: '',
            loadComponent: () => import('./features/integration-list/integration-list.component').then((m) => m.IntegrationListComponent),
          },
          {
            path: 'create',
            canActivate: [requirePermissions('INTEGRATION_WRITE')],
            loadComponent: () => import('./features/integration-create/integration-create.component').then((m) => m.IntegrationCreateComponent),
          },
          {
            path: ':integrator/:version/update',
            canActivate: [requirePermissions('INTEGRATION_WRITE')],
            loadComponent: () => import('./features/integration-update/integration-update.component').then((m) => m.IntegrationUpdateComponent),
          },
        ],
      },
      {
        path: 'user-management',
        canActivate: [requirePermissions('USER_MANAGEMENT')],
        loadComponent: () => import('./features/user-management/user-management.component').then((m) => m.UserManagementComponent),
      },
    ],
  },
  {
    path: 'callback',
    loadComponent: () => import('./shared/components/callback/callback.component').then((m) => m.CallbackComponent),
  },
  {
    path: 'error/:error-code',
    loadComponent: () => import('./features/error-page/error-page.component').then((m) => m.ErrorPageComponent),
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];
